import type { Product } from '@/types';
import { Container } from '@/components/atoms';

export function Dosing({ product }: { product: Product }) {
  if (!product.dosingInstructions) return null;
  return (
    <Container className="py-8">
      <div className="rounded-card border border-night-blue/10 p-6">
        <h2 className="mb-2 font-condensed text-xl font-bold text-night-blue">Recommended use</h2>
        <p className="text-night-blue/70">{product.dosingInstructions}</p>
      </div>
    </Container>
  );
}
